import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root') as HTMLElement;

// In production, scripts/prerender.js writes the rendered tree into
// #root at build time so AI agents and SEO crawlers see real content.
// React attaches to that DOM via hydrateRoot. In dev (or any case where
// #root is empty), fall through to createRoot.
if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
